import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { IFateCard } from 'types/fate';


import PurchaseModal from '../PurchaseModal';
import FateCardComponent from './FateCardComponent';

type Props = {
  data: IFateCard,
};

type State = {
  isDialogOpen: boolean,
};

export class FateCardContainer extends Component<Props, State> {
  mounted = false;

  state = {
    isDialogOpen: false,
  };

  componentDidMount = () => {
    this.mounted = true;
  };

  componentWillUnmount = () => {
    this.mounted = false;
  };

  handleClick = () => {
    this.setState({ isDialogOpen: true });
  };

  handleRequestClose = () => {
    if (this.mounted) {
      this.setState({ isDialogOpen: false });
    }
  };

  render = () => {
    const { data } = this.props;
    const { isDialogOpen } = this.state;
    return (
      <Fragment>
        <FateCardComponent
          data={data}
          onClick={this.handleClick}
        />
        <PurchaseModal
          data={data}
          isOpen={isDialogOpen}
          onRequestClose={this.handleRequestClose}
        />
      </Fragment>
    );
  }
}

export default connect()(FateCardContainer);